var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { ToolIcons } from '../../models/tool-icons.const';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { EngineState } from '../../state/engine.state';
import { SetActiveTool, ToggleLabels, PlayAnimation } from '../../state/engine.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Undo, Redo, RevertChapterSynchronization, CopyChapterSynchronization } from 'src/app/history/state/history.actions';
import { PaintPresets, PaintPresetFade, PaintPresetOriginal } from 'src/app/engine/models/paint-presets.const';
import { EngineNodesState } from '../../state/nodes/engine.nodes.state';
import { PaintService } from '../../paint.service';
import { HistoryState } from 'src/app/history/state/history.state';
import { SetChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { ChapterService } from 'src/app/story/chapter.service';
import { takeUntil } from 'rxjs/operators';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { SetObjectVisibility } from 'src/app/edit/state/edit.actions';
import { Router } from '@angular/router';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
var EngineToolBarComponent = /** @class */ (function () {
    function EngineToolBarComponent(store, paintService, chapterService, graphService, changeDetector, router, zendeskService) {
        this.store = store;
        this.paintService = paintService;
        this.chapterService = chapterService;
        this.graphService = graphService;
        this.changeDetector = changeDetector;
        this.router = router;
        this.zendeskService = zendeskService;
        this.toolEnum = ToolEnum;
        this.toolIcons = ToolIcons;
        this.paintPresets = PaintPresets;
        this.leaves = [];
        this.count = 0;
        this.ngUnsubscribe = new Subject();
    }
    EngineToolBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodes) {
            _this.leaves = _this.getLeaves(nodes);
            _this.count = _this.leaves.length;
            _this.changeDetector.markForCheck();
        });
    };
    EngineToolBarComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EngineToolBarComponent.prototype.handleUndoClick = function () {
        this.undo();
    };
    EngineToolBarComponent.prototype.handleRedoClick = function () {
        this.redo();
    };
    EngineToolBarComponent.prototype.handleResetClick = function () {
        this.reset();
    };
    EngineToolBarComponent.prototype.handleShowSelected = function () {
        this.store.dispatch(new SetObjectVisibility(this.store.selectSnapshot(EngineNodesState.getCheckedNodes), true));
    };
    EngineToolBarComponent.prototype.handleShowInverse = function () {
        var nodes = this.getInverseSelectedNodes();
        this.store.dispatch(new SetObjectVisibility(nodes, true));
    };
    EngineToolBarComponent.prototype.handleHideSelected = function () {
        this.store.dispatch(new SetObjectVisibility(this.store.selectSnapshot(EngineNodesState.getCheckedNodes), false));
    };
    EngineToolBarComponent.prototype.handleHideInverse = function () {
        var nodes = this.getInverseSelectedNodes();
        this.store.dispatch(new SetObjectVisibility(nodes, false));
    };
    EngineToolBarComponent.prototype.handleFadeSelected = function (inverse) {
        if (inverse === void 0) { inverse = false; }
        var nodes = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
        var inverseNodes = this.getInverseSelectedNodes();
        if (inverse) {
            this.paintService.paintAll(nodes, PaintPresetOriginal.recipe);
            this.paintService.paintAll(inverseNodes, PaintPresetFade.recipe);
        }
        else {
            this.paintService.paintAll(nodes, PaintPresetFade.recipe);
            this.paintService.paintAll(inverseNodes, PaintPresetOriginal.recipe);
        }
    };
    EngineToolBarComponent.prototype.handleNavigate = function (url) {
        this.router.navigateByUrl(url);
    };
    EngineToolBarComponent.prototype.handleHelpClicked = function () {
        this.showZendeskWidget();
    };
    EngineToolBarComponent.prototype.showZendeskWidget = function () {
        this.zendeskService.activate({
            hideOnClose: true
        });
    };
    EngineToolBarComponent.prototype.getInverseSelectedNodes = function () {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var nodeIds = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(viewGraph, nodeIds);
        return this.graphService.getNodes(viewGraph, inverseNodeIds);
    };
    EngineToolBarComponent.prototype.getLeaves = function (nodes) {
        if (!nodes) {
            return [];
        }
        return this.graphService.getAllLeafDescendants(this.store.selectSnapshot(EngineState.getViewGraph), nodes.map(function (node) { return node.id; }));
    };
    EngineToolBarComponent.prototype.toggleTool = function (tool) {
        this.store.dispatch(new SetActiveTool(tool));
    };
    EngineToolBarComponent.prototype.toggleLabels = function () {
        var showLabels = !this.store.selectSnapshot(EngineState.getShowLabels);
        this.store.dispatch(new ToggleLabels(showLabels));
    };
    EngineToolBarComponent.prototype.play = function () {
        var playing = !this.store.selectSnapshot(EngineState.getAnimationPlaying);
        this.store.dispatch(new PlayAnimation(playing));
    };
    EngineToolBarComponent.prototype.undo = function () {
        this.store.dispatch(new Undo());
    };
    EngineToolBarComponent.prototype.redo = function () {
        this.store.dispatch(new Redo());
    };
    EngineToolBarComponent.prototype.reset = function () {
        var chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        this.store.dispatch(new RevertChapterSynchronization('root', chapter.id));
        this.store.dispatch(new CopyChapterSynchronization('root', chapter.id, 'cache', chapter.id));
        var cache = this.store.selectSnapshot(HistoryState).cache;
        var synchronization = cache["root_" + chapter.id];
        chapter = __assign({}, chapter, { synchronization: __assign({}, synchronization) });
        this.store.dispatch(new SetChapter(chapter));
        this.chapterService.addChapterToEngine(chapter, 0);
    };
    __decorate([
        Select(EngineState.getShowLabels),
        __metadata("design:type", Observable)
    ], EngineToolBarComponent.prototype, "showLabels$", void 0);
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EngineToolBarComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], EngineToolBarComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EngineToolBarComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EngineToolBarComponent.prototype, "checkedNodes$", void 0);
    return EngineToolBarComponent;
}());
export { EngineToolBarComponent };
